import React from 'react';
import { SelectField } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';

const styles = {
  greenText: { color: green[500] },
  orangeText: { color: orange[500] },
  redText: { color: red[500] }
};

const StatusSelectField = withStyles(styles)(({ classes, ...props }) => {
  let optionClass = '';
  const status =
    props.record &&
    (props.record.status ||
      props.record.batchStatus ||
      props.record.activeVersion);
  switch (status) {
    case 'ACTIVE':
    case 'A':
      optionClass = classes.greenText;
      break;
    case 'INVITED':
    case 'INACTIVE':
    case 'PENDING':
    case 'OFFLINE':
    case 'P':
      optionClass = classes.orangeText;
      break;
    case 'SUSPENDED':
    case 'S':
      optionClass = classes.redText;
      break;
    default:
      break;
  }

  return <SelectField sortable={false} className={optionClass} {...props} />;
});

export default StatusSelectField;
